export const msToTimecode = (ms: number): string => {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const timecodeToMs = (timecode: string): number => {
  const [minutes, seconds] = timecode.split(':').map(Number);
  return (minutes * 60 + seconds) * 1000;
};
